import { LitElement, html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

import { LIT_CSS_VARIABLES, GRID_LAYOUT } from '@Root/lib/lit-styles.js';
import { SHARED_CLASSES, SHARED_ELEMENTS } from './styles.js';
import { imagebossUrl } from '../../helpers/imageboss';
import { debounce } from '../../helpers/debounce';

export class Lit3formBlock extends LitElement {
  static defineElement() {
    customElements.define(`${this.characterName}-block`, this);
  }

  static get styles() {
    return [
      LIT_CSS_VARIABLES,
      SHARED_ELEMENTS,
      SHARED_CLASSES,
      GRID_LAYOUT,
      ...this.characterStyles,
    ];
  }

  static get characterStyles() {
    return [];
  }

  static get properties() {
    return {
      content: { type: Object },
      cart: { type: Object },
      _useMobileLayout: { type: Boolean },
      ...this.characterProperties,
    };
  }

  static get characterProperties() {
    return {};
  }

  constructor() {
    super();

    this.content = JSON.parse(this.getAttribute('content'));
    this._useMobileLayout = !window.matchMedia('(min-width: 600px)').matches;
  }

  connectedCallback() {
    super.connectedCallback();

    this.removePlaceholderDiv();
    window.addEventListener(
      'resize',
      debounce(this._handleMobileTransition, 50)
    );
  }

  _handleMobileTransition() {
    const useMobile = !window.matchMedia('(min-width: 600px)').matches;
    if (this._useMobileLayout !== useMobile) {
      this._useMobileLayout = useMobile;
      const useMobileEvent = new CustomEvent('useMobileEvent', {
        detail: {
          useMobile,
        },
        bubbles: true,
        composed: true,
      });
      window.dispatchEvent(useMobileEvent);
    }
  }

  removePlaceholderDiv() {
    const el = document.querySelector(
      `.js-${this.characterName}-block-${this.content.id}`
    );
    if (!!el) el.remove();
  }

  get characterName() {
    return this.constructor.characterName;
  }

  get horizontalRule() {
    return this.hideSucceedingHorizontalRule
      ? html``
      : html`
          <horizontal-rule
            style="${styleMap(this.horizontalRuleStyles)}"
            class="print-none"
          ></horizontal-rule>
        `;
  }

  get horizontalRuleStyles() {
    return {
      'border-bottom-width': this.hideSucceedingHorizontalRule ? '0' : '1px',
    };
  }

  get hideSucceedingHorizontalRule() {
    return this.content.hide_succeeding_horizontal_rule;
  }

  get addToCartQuantity() {
    return 1;
  }

  imagebossUrl(imageUrl, width, height) {
    return imagebossUrl(imageUrl, { width, height });
  }

  withLineBreaks(string) {
    return !string ? '' : string.split(/\r\n|\n/g).join('<br>');
  }
}

export * from 'lit';
export { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
export { ifDefined } from 'lit/directives/if-defined.js';
export { classMap } from 'lit/directives/class-map.js';

export * from './components/cta-button';
export * from './components/cta-text';
export * from './components/cta-text-with-icon';
export * from './components/download-button';
export * from './components/horizontal-rule';
export * from './components/styled-multi-select';
export * from './components/dialog-modal';
